export const smartBandTranslations = {
    fa: {
        title: "مقایسه دستبندهای هوشمند",
        subtitle: "دلبند",
        description: "ویژگی‌های دستبندهای هوشمند مختلف دلبند را مقایسه کنید تا بهترین انتخاب را برای نیازهای خود داشته باشید.",
    },
    en: {
        title: "Smart Band Comparison",
        subtitle: "Delband",
        description: "Compare different Delband smart bands features to make the best choice for your needs.",
    },
    ar: {
        title: "مقارنة السوار الذكي",
        subtitle: "دلبند",
        description: "قارن بين ميزات أساور دلبند الذكية المختلفة لاتخاذ الخيار الأفضل لاحتياجاتك.",
    },
    tr: {
        title: "Akıllı Bileklik Karşılaştırması",
        subtitle: "Delband",
        description: "İhtiyaçlarınız için en iyi seçimi yapmak üzere farklı Delband akıllı bileklik özelliklerini karşılaştırın.",
    },
};
